import React from "react";
import { H4 } from "../Text";

interface P {
  value: string;
}

const Title = ({ value }: P) => <H4>{value}</H4>;

export default React.memo(Title);
